<template>
  <Modal class="mask long-modal"  width="820" v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">发送签约邀请</div>
    <Form :model="formData" :label-width="140" :rules="formRules" ref="inviteForm">
      <FormItem label="项目信息" prop="projectName">
        <Input v-model="formData.projectName" class="item-width" :disabled="true"></Input>
      </FormItem>
       <FormItem label="房间信息" prop="houseNumber">
        <Input v-model="formData.houseNumber" class="item-width" :disabled="true"></Input>
      </FormItem>
      <Row :gutter="16">
        <Col span="11">
          <FormItem label="签约人手机号" prop="phone">
            <Input v-model="formData.phone" class="item-width" @on-change="handleFirstChange"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16" v-if="showOtherPhone">
        <Col span="11">
          <FormItem label="签约人其他手机号" prop="otherPhone">
            <Input v-model="otherPhone" class="item-width" @on-change="handleOtherChange"></Input>
          </FormItem>
        </Col>
        <Col span="13">
          <div class="message">{{noBusinessMsg}}</div>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="11">
          <FormItem label="客户来源" prop="channelType">
            <Select v-model="formData.channelType" @on-change="channelTypeChange" class="item-width" :disabled="channelTypeDisabled">
              <Option v-for="item in channelTypeList" :value="item.value" :key="item.value" v-show="item.show">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem v-if="[5,8].indexOf(formData.channelType)!==-1" prop="channelUserCode" class="my-form-item">
            <Input v-model="formData.channelUserCode" placeholder="工号" class="item-width1"></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem v-if="[5,8].indexOf(formData.channelType)!==-1" prop="channelUserName" class="my-form-item">
            <Input v-model="formData.channelUserName" placeholder="姓名" :disabled="this.channelName" class="item-width1"></Input>
          </FormItem>
        </Col>
      </Row>
      <FormItem label="租期方式" prop="conType">
        <Select v-model="formData.conType" @on-change="clearBackToRentDay" class="item-width">
          <Option v-for="item in leaseTime" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="租期时间" prop="conEndDate">
        <DatePicker ref="conStartDate" id="start-date" type="date" :disabled="true" v-model="formData.conStartDate" class="item-width" ></DatePicker>
        <DatePicker ref="conEndDate" v-if="formData.conType == 1" type="date"  class="item-width"  v-model="formData.conEndDate" :options="options1" placeholder="到期日" :clearable="false"></DatePicker>
        <DatePicker ref="conEndDate" v-if="formData.conType == 2" type="date"  class="item-width"  v-model="formData.conEndDate" :options="options2" placeholder="到期日" @on-change="getTime"></DatePicker>
        <DatePicker ref="conEndDate" v-if="formData.conType === 0" type="date" :disabled="true" v-model="formData.conEndDate" placeholder="退租日"></DatePicker>
        <div class="time-box" v-if="formData.conType == 1 && year ">{{year}}年</div>
        <div class="time-box" v-if="(formData.conType == 2 || formData.conType === 0) && month">{{month}}月</div>
        <div class="time-box" v-if="(formData.conType == 2 || formData.conType === 0) && day">{{day}}天</div>
      </FormItem>
      <Row :gutter="16">
        <Col span="20">
          <FormItem label="客户通过哪些途径了解的该房源？(可多选)" prop="housePath">
            <Checkbox-group v-model="formData.housePath">
                <Checkbox v-for="(item,index) in housePaths" 
                :key="'floor'+index"
                :label="item.value+':'+item.text"
                >{{item.text}}</Checkbox>
              </Checkbox-group>
          </FormItem>
        </Col>
      </Row>
    </Form>

    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="signInviteList" :loading="tableLoading"></table-list>
    </div>

    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" @click="send" :loading="loading">
          <span v-if="!loading">发送</span>
          <span v-else>发送中...</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
  import {formatDateTime} from "@/utils/format";
  import { validSignInvite, saveSignInviteInfo } from "api/signInvite";
  import {getLast30DaysBusiness} from 'api/business';
  import TableList from "components/TableList/index";
  import { getEHRUserDetail } from 'api/managementCenter'
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    stockNumber:{
      type: String,
      default:''
    },
    cityCode:{
      type:String,
      default:''
    },
    userPhone:{
      type:String,
      default:''
    },
    rentType:{
      type:String,
      default:''
    },
    signInviteInfo:{
      type: Object,
      default:null
    },
    isReservation:{
      type:Number,
      default:0
    }

  },
  watch:{
    n(){
      this.$refs['inviteForm'].resetFields();
      this.loading = false
      this.show = true
      this.showOtherPhone = false,
      this.otherPhone = '',
      this.noBusinessMsg = '',
      this.channelTypeDisabled = true
    },
    signInviteInfo:{
      deep: true,
      handler(val){
        this.housePaths = val.housePaths
        this.signInviteList = val.signInviteList ? val.signInviteList : []
        this.minRentDay = val.rentTermMonthStart
        this.maxRentDay = val.rentTermMonthEnd
        this.minRentYear = val.rentTermYearStart
        this.maxRentYear = val.rentTermYearEnd
        this.stockMaxSignDate = val.stockMaxSignDate
        this.formData.stockMaxSignDate = val.stockMaxSignDate
        this.leaseTime = val.leaseTime
        this.formData.roomIds = val.stockFid
        this.formData.projectCode = val.projectCode
        this.formData.projectCooperationModel = val.projectCooperationModel
        this.formData.projectId = val.projectFid
        this.formData.projectName = val.projectName
        this.formData.stockType = val.stockType
        this.formData.stockRentType = val.stockRentType
        this.formData.houseNumber = this.stockNumber
        this.formData.cityCode = this.cityCode
        this.formData.phone = this.userPhone
        if (this.userPhone) { this.handleFirstChange() }
        this.channelTypeList = val.channelType
        if(this.isReservation === 1){
          this.formData.isReservation = 1
        }
      }
    }

  },
  components:{
    TableList
  },
  data () {
    const validateContactPhone = (rule, value, callback) => {
      const pattern = /^1\d{10}$/
      if(!pattern.test(value)){
        callback(new Error('输入正确的联系方式'));
      } else {
        validSignInvite(value,this.formData.projectId).then(res => {
          callback()
          if(res.code !== 0 ) {
            this.$Message.error(res.message);
          }
        }).catch(() => {
          callback()
        })
      }
    }
    const validateOtherPhone = (rule, value, callback) => {
      const pattern = /^1\d{10}$/
      if(value && !pattern.test(value)){
        callback(new Error('输入正确的联系方式'));
      }
      callback()
    }
    const validateChannelUserCode = (rule, value, callback) => {
      const pattern = /^[0-9]+$/

      if(!pattern.test(value)){
        this.formData.channelUserName = ''
        this.formData.channelUserPhone = ''
        this.formData.channelContrastJobCode = ''
        this.formData.channelSuperEmpCode = ''
        this.formData.channelDept = ''
        this.formData.channelDeptCode = ''
        this.formData.channelCenter = ''
        this.formData.channelCenterCode = ''
        this.formData.channelGroup = ''
        this.formData.channelGroupCode = ''
        callback(new Error('输入正确的工号'));
      } else {
        if(!this.sendUp){

          this.formData.channelUserName = ''
          this.formData.channelUserPhone = ''
          this.formData.channelContrastJobCode = ''
          this.formData.channelSuperEmpCode = ''
          this.formData.channelDept = ''
          this.formData.channelDeptCode = ''
          this.formData.channelCenter = ''
          this.formData.channelCenterCode = ''
          this.formData.channelGroup = ''
          this.formData.channelGroupCode = ''

          getEHRUserDetail({userCode:this.formData.channelUserCode}).then( res => {
            if(res.code !== 0 ) {
              this.channelName = false
              this.$Message.error(res.message);
            } else {
              if (res.data.name) {
                this.channelName = true
                this.formData.channelUserName = res.data.name
                this.formData.channelUserPhone = res.data.phone
                this.formData.channelContrastJobCode = res.data.contrastJobCode
                this.formData.channelSuperEmpCode = res.data.superEmpCode
                this.formData.channelDept = res.data.dept
                this.formData.channelDeptCode = res.data.deptCode
                this.formData.channelCenter = res.data.center
                this.formData.channelCenterCode = res.data.centerCode
                this.formData.channelGroup = res.data.groupName
                this.formData.channelGroupCode = res.data.groupCode
              } else {
                this.channelName = false
                this.$Message.error("未查询到管家信息,请输入管家姓名");
              }
              callback();
            }
          })
        } else {
          callback();
        }
      }
    }
    const validatTujing = (rule, value, callback) => {
        if (value.length==0) {
          callback(new Error("请选择看房途径"));
        }
        callback();
      };
    return {
      housePaths:[],
      tableLoading:false,
      loading:false,
      show:false,
      channelName:true,
      stockMaxSignDate:null,
      sendUp:false,
      //rentTypeList:[],
      leaseTime:[],
      channelTypeList:[],
      maxRentDay:0,
      minRentDay:0,
      minRentYear:0,
      maxRentYear:0,
      signInviteList:[],
      columns:[
        {
          type:'index',
          width:60,
          align:'center'
        },
        {
          title: "签约手机号",
          key: "userPhone",
          align: "center"
        },
        {
          title: '租期类型',
          key: "rentTypeName",
          align: "center"
        },
        {
          title: "起租日",
          key: "conStartDate",
          align: "center",
          render: (h,params) => {
            return h('span',formatDateTime(params.row.conStartDate,false))
          }
        },
        {
          title:'到期日',
          key: "conEndDate",
          align: "center",
          render: (h,params) => {
            return h('span',formatDateTime(params.row.conEndDate,false))
          }
        },
        {
          title:'ZO',
          key: "handleZo",
          align: "center"
        },
        {
          title:'发送日期',
          key: "createTime",
          align: "center",
          render: (h,params) => {
            return h('span',formatDateTime(params.row.createTime,false))
          }
        },
      ],
      phoneData:{
        phone:'',
        projectFId:''
      },
      formData:{
        housePath:[],
        cityCode: '',
        conEndDate: '',
        conStartDate: formatDateTime(new Date(),false),
        conType: '',
        // customerUid: '', //是否要传
        houseNumber: '',
        phone: '',
        projectCode: '',
        projectCooperationModel: 0,
        projectId: '',
        projectName: '',
        roomIds: '', // stockFid
        signContractType: '0',
        stockMaxSignDate:'',
        stockRentType:'',
        stockType:'',
        isReservation:0,
        channelType: '',
        channelUserCode: '',
        channelUserName: '',
        channelUserPhone: '',
        channelSuperEmpCode: '',
        channelContrastJobCode: '',
        channelDept: '',
        channelDeptCode: '',
        channelCenter: '',
        channelCenterCode: '',
        channelGroup: '',
        channelGroupCode: '',
        businessFid: ''
      },
      formRules:{
        phone:[{ required:true, validator:validateContactPhone, trigger:'blur' }],
        otherPhone:[{validator: validateOtherPhone, trigger:'blur'}],
        conType:[{required:true, type:'number', message:'请选择租期方式', trigger:'change'}],
        conEndDate:[ {required:true, message:'请选择到期时间', trigger:'change', type:'object' }],
        channelType:[ {required:true, type:'number', message:'请选择客户来源', trigger:'change'}],
        channelUserCode:[{ required:true, validator:validateChannelUserCode, trigger:'blur' }],
        channelUserName:[{ required:true, message:'请输入姓名', trigger:'change',type:'string' }],
        housePath:[{required: true, message: "请选择了解途径", validator:validatTujing, trigger: "change"}]

      },
      year:0,
      month:0,
      day:0,
      showOtherPhone: false,
      otherPhone: '',
      noBusinessMsg: '',
      channelTypeDisabled: true
    }
  },
  computed: {
    options1(){
      const _this = this
      const shortcuts = []

      const min = this.minRentYear
      let max = this.maxRentYear

      let temDate = 0
      const temDateArr = []
      for(let i=min;i<max+1;i++) {
        temDate = this.setDate(i)
        if (temDate.valueOf() > this.stockMaxSignDate) {
          max = i-1;
          break;
        }
      }
      for(let i=min;i<max+1;i++) {

        shortcuts.push ({
          text: `${i}年`,
          value () {
            return _this.setDate(i)
          },
          onClick: (picker) => {
              _this.year = i
            }
        })
      }
      return {
        disabledDate (date) {
          return date && date.valueOf();
        },
        shortcuts:shortcuts
      }

    },
    options2(){
      const max = this.maxRentDay
      const min = this.minRentDay
      const now = new Date()

      let minTime = now.valueOf() + 3600*24*1000*(min-2)
      let maxTime = now.valueOf() + 3600*24*1000*(max-1)

      minTime = minTime > this.stockMaxSignDate ? this.stockMaxSignDate : minTime
      maxTime = maxTime > this.stockMaxSignDate ? this.stockMaxSignDate : maxTime
      return {
        disabledDate (date) {
          return date && date.valueOf() < minTime|| date.valueOf() > maxTime;
        }
      }
    }
  },
  methods: {
    cancel(){
      this.show = false
    },
    clearBackToRentDay(val){
      this.formData.conEndDate = ''
      this.year = 0
      this.month= 0
      this.day = 0
      if(val === 0) {
        this.formData.conEndDate = formatDateTime(this.stockMaxSignDate,false)
      this.getTime(this.formData.conEndDate)
      }else if(val ===2){
        const endDate = new Date().valueOf() + 3600*24*1000*(this.minRentDay -1)
        const nowDate = new Date()
        const arr = this.getDateArry(formatDateTime(nowDate,false),formatDateTime(endDate,false))
        if (arr[1] === 0){
          this.formData.conEndDate = formatDateTime(endDate,false)
        } else {
          const endDate1 = new Date()
          endDate1.setMonth(nowDate.getMonth()+arr[0]+1)
          endDate1.setDate(endDate1.getDate()-1)
          this.formData.conEndDate = formatDateTime(endDate1,false)
        }
        this.getTime(this.formData.conEndDate)
      }else if(val ===1) {
          this.year = this.minRentYear
          this.formData.conEndDate = this.setDate(this.minRentYear)
      }
    },
    getDateExp(ref) {
      if(typeof this.formData[ref]==='object'){
        this.formData[ref] = this.$refs[ref].publicStringValue
      }
    },
    getDateArry(d1,d2){
      const s1 = d1.split("-")
      const s2 = d2.split("-")
      return  this.calcuateDuration(s2[0],s2[1],s2[2],s1[0],s1[1],s1[2])
    },
    getTime(val){
      if(!val) return
      const now = new Date()
      const curYear = now.getFullYear()
      const curMonth = now.getMonth()
      const curDate = now.getDate()

      const dateArr = val.split('-')
      const year = +dateArr[0]
      const month = +dateArr[1]-1
      const date = +dateArr[2]

      const arr = this.calcuateDuration(year,month,date,curYear,curMonth,curDate)
      this.month = arr[0]
      this.day = arr[1]
    },
    calcuateDuration(year,month,date,curYear,curMonth,curDate){
      // month 当月实际数减1
      let diffMonth = 0
      let diffDay  = 0

      const curMonthDays = new Date(year,month+1,0).getDate()
      const preMonthDays = new Date(year,month,0).getDate() // 获取上个月的天数

      if(date >= curDate){
        diffDay = date - curDate + 1
        diffMonth = year - curYear > 0 ? month - curMonth + 12 : month - curMonth
      } else {
        if(date === curDate-1 || date===curMonthDays){
          diffDay = 0
          diffMonth = year - curYear > 0 ? month - curMonth + 12 : month - curMonth
        } else {
          diffDay = preMonthDays - curDate + 1 <= 0 ? date : preMonthDays - curDate + 1 +date
          diffMonth = year - curYear > 0 ? month - curMonth + 11 : month - curMonth -1
        }
      }
      return [diffMonth,diffDay]
    },
    setDate(num){
      const date = new Date();
      if(date) {
        const year = date.getFullYear() + num
        const month = date.getMonth()
        const day = date.getDate()-1
        return new Date(year,month,day)
        // return `${year}-${month}-${day}`;
      }
    },
    send(){
      this.formData.cityCode = this.cityCode
      this.sendUp = true
       this.$refs['inviteForm'].validate( bool => {
         this.sendUp = false
         if(bool) {
            this.loading = true
            this.getDateExp('conStartDate')
            this.getDateExp('conEndDate')
          // if(typeof this.formData.conStartDate == 'object'){
          //   this.formData.conStartDate = formatDateTime(this.formData.conStartDate,false)
          // }
          // if(typeof this.formData.conEndDate == 'object'){
          //   this.formData.conEndDate = formatDateTime(this.formData.conEndDate,false)
          // }
          saveSignInviteInfo(this.formData).then( res => {
             this.$Message.success('邀请成功!');
             this.loading = false
             this.$emit('done')
            this.show = false
          }).catch( res => {
            this.loading = false
          })

         }
       })
    },
    channelTypeChange() {
      this.formData.channelUserCode = ''
      this.formData.channelUserName = ''
      this.formData.channelUserPhone = ''
      this.formData.channelSuperEmpCode = ''
      this.formData.channelContrastJobCode = ''
      this.formData.channelDept = ''
      this.formData.channelDeptCode = ''
      this.formData.channelCenter = ''
      this.formData.channelCenterCode = ''
      this.formData.channelGroup = ''
      this.formData.channelGroupCode = ''
      this.formData.housePaths = []

    },

    resetFormItem (val) {
      this.$refs['inviteForm'].fields.forEach(item => {
        if (item.prop === val) {
          item.resetField()
        }
      })
    },

    handleFirstChange() {
      if (!this.otherPhone) {
        this.noBusinessMsg = ''
        this.formData.channelType = ''
        this.resetFormItem('channelType')
      }
      if(this.formData.phone && /^1\d{10}$/.test(this.formData.phone)) {
        const params = {
          projectFid: this.formData.projectId,
          customerPhone: this.formData.phone,
          times: 'first'
        }
        getLast30DaysBusiness(params).then(res => {
          if (res.data.fid) {
            this.showOtherPhone = false
            this.channelTypeDisabled = true
            
            this.formData.businessFid = res.data.fid
            this.formData.channelType = res.data.channelType
            this.$nextTick(() => {
              if ([5,8].indexOf(this.formData.channelType) !== -1) {
                this.formData.channelUserCode = res.data.channelUserCode
                this.formData.channelUserName = res.data.channelUserName
              }
            })
          } else {
            this.showOtherPhone = true
            if (!this.otherPhone) {
              this.channelTypeDisabled = false
              this.noBusinessMsg = res.data.msg
            }
          }
        })
      }
    },
    handleOtherChange() {
      this.formData.channelType = ''
      this.resetFormItem('channelType')
      if(this.otherPhone && /^1\d{10}$/.test(this.otherPhone)) {
        const params = {
          projectFid: this.formData.projectId,
          customerPhone: this.otherPhone,
          times: 'other'
        }
        getLast30DaysBusiness(params).then(res => {
          if (res.data.fid) {
            this.channelTypeDisabled = true
            this.noBusinessMsg = ''

            this.formData.businessFid = res.data.fid
            this.formData.channelType = res.data.channelType
            this.$nextTick(() => {
              if ([5,8].indexOf(this.formData.channelType) !== -1) {
                this.formData.channelUserCode = res.data.channelUserCode
                this.formData.channelUserName = res.data.channelUserName
              }
            })
          } else {
            this.noBusinessMsg = res.data.msg
          }
        })
      } else {
        this.channelTypeDisabled = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.time-box {
  margin-left: 8px;
  display: inline-block;
  padding-left:8px;
  padding-right: 8px;
  line-height: 30px;
  border: 1px solid #DDDEE1;
  border-radius: 2px;
}
.item-width1 {
  width: 180px;
}
.my-form-item {
  /deep/ .ivu-form-item-content {
    margin-left: 0 !important;
  }
}
.message {
  color: red;
  padding-top: 8px;
}
</style>
